import { render, staticRenderFns } from "./ConfiguracionArticulo.vue?vue&type=template&id=69e644b1"
import script from "./ConfiguracionArticulo.vue?vue&type=script&lang=js"
export * from "./ConfiguracionArticulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports